import {
  MARK_AS_SUCCESS_PENDING,
  MARK_AS_SUCCESS_SUCCESS,
  MARK_AS_SUCCESS_ERROR,
  MARK_AS_FAILURE_PENDING,
  MARK_AS_FAILURE_SUCCESS,
  MARK_AS_FAILURE_ERROR,
  OPEN_MARK_AS_SUCCESS_MODAL,
  CLOSE_MARK_AS_SUCCESS_MODAL,
  OPEN_MARK_AS_FAILURE_MODAL,
  CLOSE_MARK_AS_FAILURE_MODAL,
} from '../../actions/ifu/ifu_generation';

const initialState = {
  pending: false,
  error: null,
  mark_as_success_modal: false,
  mark_as_failure_modal: false,
};

export function ifuGenerationReducer(state = initialState, action) {
  switch (action.type) {
    // Modals

    case OPEN_MARK_AS_SUCCESS_MODAL:
      return {
        ...state,
        mark_as_success_modal: true,
      };
    case CLOSE_MARK_AS_SUCCESS_MODAL:
      return {
        ...state,
        mark_as_success_modal: false,
      };
    case OPEN_MARK_AS_FAILURE_MODAL:
      return {
        ...state,
        mark_as_failure_modal: true,
      };
    case CLOSE_MARK_AS_FAILURE_MODAL:
      return {
        ...state,
        mark_as_failure_modal: false,
      };

    // Axios
    case MARK_AS_SUCCESS_PENDING:
      return {
        ...state,
        pending: true,
      };

    case MARK_AS_SUCCESS_SUCCESS:
      return {
        ...state,
        pending: false,
      };

    case MARK_AS_SUCCESS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
        refresh: action.refresh,
      };
    case MARK_AS_FAILURE_PENDING:
      return {
        ...state,
        pending: true,
      };

    case MARK_AS_FAILURE_SUCCESS:
      return {
        ...state,
        pending: false,
      };

    case MARK_AS_FAILURE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
        refresh: action.refresh,
      };

    default:
      return state;
  }
}

export const getPending = (state) => state.ifuGenerationReducer.pending;
export const getRefresh = (state) => state.ifuGenerationReducer.refresh;
export const getMarkAsSuccessModal = (state) => state.ifuGenerationReducer.mark_as_success_modal;
export const getMarkAsFailureModal = (state) => state.ifuGenerationReducer.mark_as_failure_modal;
